import React from 'react';
import { Link } from 'react-router-dom';
import { formatRoute } from 'react-router-named-routes';

import {
  Paper, Typography, Grid,
} from '@material-ui/core';

import classes from '../../css/getCSS';
import * as routes from '../../config/routes';


const eventitem = (props) => {
  let classNames = [classes.card];
  if (props.showCaption) {
    classNames.push(classes.sidebarItem);
  }
  if (props.homeItem) {
    classNames = [classes.card, classes.cardHomeItem];
  } else {
    classNames = [classes.card, classes.cardFancy];
  }
  return (
    <Link className={classes.linkDeCSS} to={formatRoute(routes.EVENT_DETAIL, { slug: props.slug })}>
      <Paper className={classNames.join(' ')} style={{ marginBottom: '10px' }} align="left">
        {props.showCaption ? <Typography variant="caption" style={{ fontSize: '15px' }}>Event</Typography> : null}
        <Typography variant="title" style={{ marginBottom: '5px', fontSize: '20px' }}>{props.title}</Typography>
        <Typography variant="body1">Venue: {props.venue}</Typography>
        <Typography variant="body1">Time: {props.event_on}</Typography>
        <Grid container style={{ marginTop: '10px' }}>
          <Grid item md={6} sm={6} xs={6}>
            <Typography variant="body1">
              Registrations Open: &nbsp;
              <span style={{ display: 'inline-block', marginRight: '5px' }}>Boys: {props.boys_open ? <i className="far fa-check-circle fa-sm" /> : <i className="far fa-times-circle fa-sm" />}</span>
              <span style={{ display: 'inline-block' }}>Girls: {props.girls_open ? <i className="far fa-check-circle fa-sm" /> : <i className="far fa-times-circle fa-sm" />}</span>
            </Typography>
          </Grid>
        </Grid>
      </Paper>
    </Link>
  );
};

export default eventitem;



// WEBPACK FOOTER //
// ./src/main/components/EventListItem.js